module.exports = {
  US: /^\d{5}(?:[-\s]\d{4})?$/,
  GB: /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i,
  CA: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
};
